import React, { useEffect, useState } from "react";
import styles from './ChangePasswordForm.module.scss';
import PasswordField from "../passwordField/PasswordField";
import TextField from "../textField/TextField";
import Checkbox from "../checkbox/Checkbox";
import Button from "../button/Button";
import PropTypes from "prop-types";
import Alert from "../alert/Alert";

const ChangePasswordForm = ({
  formData,
  onSubmit,
  error,
  success,
}) => {
  const [oldPassword, setOldPassword] = useState('');
  const [oldPasswordError, setOldPasswordError] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [newPasswordError, setNewPasswordError] = useState('');
  const [newPasswordHasError, setNewPasswordHasError] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    setOldPassword(formData?.oldPassword);
    setNewPassword(formData?.newPassword);
    setConfirmPassword(formData?.confirmPassword);
  }, [formData]);
  
  const validateOldPassword = () => {
    if(!oldPassword) {
      return 'Old Password is required';
    }
    return '';
  }
  
  const validateNewPassword = () => {
    if(!newPassword) {
      return 'New Password is required';
    }
    return '';
  }
  
  const validateConfirmPassword = () => {
    if(!confirmPassword) {
      return 'Confirm Password is required';
    }
    if(confirmPassword !== newPassword) {
      return 'New Password and Confirm Password does not match';
    }
    return '';
  }

  const handleChangePassword = () => {
    const oldPasswordValidationResult = validateOldPassword();
    const newPasswordValidationResult = validateNewPassword();
    const confirmPasswordValidationResult = validateConfirmPassword();

    setOldPasswordError(oldPasswordValidationResult);
    setNewPasswordError(newPasswordValidationResult);
    setConfirmPasswordError(confirmPasswordValidationResult);

    if (oldPasswordValidationResult || newPasswordValidationResult || confirmPasswordError) {
      return false;
    }

    if(newPasswordHasError) {
      return false;
    }

    onSubmit({
      oldPassword,
      newPassword
    });
  };

  return (
    <form
      className={styles.form}
      onSubmit={(e) => {
        e.preventDefault();
        handleChangePassword();
      }}
    >
      { error && <Alert message={error} type="error" /> }
      { success && <Alert message={success} type="success" /> }
      <TextField
        label="Old Password"
        type={showPassword ? 'text' : 'password'}
        value={oldPassword}
        onChange={(value) => {
          setOldPassword(value);
        }}
        error={oldPasswordError}
      />
      <PasswordField
        label="New Password"
        value={newPassword}
        onChange={(value, hasError) => {
          setNewPasswordError('');
          setNewPassword(value);
          setNewPasswordHasError(hasError);
          if(confirmPassword && value !== confirmPassword) {
            setConfirmPasswordError('New Password and Confirm Password does not match');
          } else {
            setConfirmPasswordError('');
          }
        }}
        showPassword={showPassword}
        error={newPasswordError}
      />
      <TextField
        label="Confirm Password"
        type={showPassword ? 'text' : 'password'}
        value={confirmPassword}
        onChange={(value) => {
          setConfirmPassword(value);
          if(value && value !== newPassword) {
            setConfirmPasswordError('New Password and Confirm Password does not match');
          } else {
            setConfirmPasswordError('');
          }
        }}
        error={confirmPasswordError}
      />
      <Checkbox
        label="Show Password"
        checked={showPassword}
        onChange={(value) => setShowPassword(value)}
      />
      <div className={styles.submit}>
        <Button
          label="Change Password"
          type="submit"
          size="small"
        />
      </div>
    </form>
  );
};

ChangePasswordForm.propTypes = {
  formData: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  success: PropTypes.string,
}

export default ChangePasswordForm;